import cloneDeep from 'lodash.clonedeep';
import { formatFormDate } from '@general/js/utils';

const mapEligibilityPayload = (caiData, changeCoverData) => {
  const eligibilityObj = cloneDeep(caiData.eligibilityInformationStep);
  eligibilityObj.declarationDate = formatFormDate(eligibilityObj.declarationDate);
  eligibilityObj.declarationExpiryDate = formatFormDate(eligibilityObj.declarationExpiryDate);

  const mappedEligibility = {
    eligibilityType: changeCoverData.step1.eligibility,
    eligibilitySubject: eligibilityObj.serviceConnection,
    subjectName: eligibilityObj.serviceConnectionName,
    subjectRank: eligibilityObj.veteranInfo?.rank ?? '',
    subjectRelation: eligibilityObj.relationship ?? '',
    subjectDepartmentOrCompanyName:
      // as "veteranInfo" without veteran card is undefined then we need to check against undefined and '' then assign the value to "subjectDepartmentOrCompanyName"
      !eligibilityObj.veteranInfo?.serviceAgency || eligibilityObj.veteranInfo?.serviceAgency === '' ? eligibilityObj.connectionName : eligibilityObj.veteranInfo?.serviceAgency,
    subjectEligibilityType: eligibilityObj.connectionType ?? '',
    subjectServiceType:
      !eligibilityObj.veteranInfo?.serviceType || eligibilityObj.veteranInfo?.serviceType === '' ? eligibilityObj.connectionType : eligibilityObj.veteranInfo?.serviceType,
    enlistmentDate: formatFormDate(eligibilityObj.enlistmentDate),
    dischargeDate: formatFormDate(eligibilityObj.dischargeDate),
    SERCATStatus: eligibilityObj.sercatStatus ?? '',
    workConnectionName: eligibilityObj.relationName ?? '',
    declarationDate: formatFormDate(eligibilityObj.declarationDate),
    expiryDate: formatFormDate(eligibilityObj.declarationExpiryDate),
    declarationIsConfirmed: eligibilityObj.declaration,
  };

  return mappedEligibility;
};

export default mapEligibilityPayload;
